'use client';
import { useTranslations } from 'next-intl';

import CalendarSvg from '@/public/icon/calendar.svg';
import { datesWithin24Hours } from '@/utils/date';
import { Format } from '@/utils/format';
import { useCurrentLocale } from '@/utils/locale/localeClient';
interface EventDateProps {
  startDate: Date;
  endDate: Date | null;
}

export default function EventDate({ startDate, endDate }: EventDateProps) {
  const t = useTranslations('Components.UI.EventDate');
  const within24Hours = datesWithin24Hours(startDate, endDate);
  const locale = useCurrentLocale();

  return (
    <div>
      {within24Hours && (
        <div className='flex items-center space-x-2'>
          <CalendarSvg />
          <p className='font-medium'>
            <span className='text-primary-filled-default'>
              {Format.date(startDate, locale, { dateStyle: 'medium' })}
            </span>
            <span className='text-out-light-gray'>, </span>
            <span className='text-white-filled-default'>
              {Format.date(startDate, locale, { timeStyle: 'short' })}
            </span>
            {endDate && (
              <>
                <span className='text-out-light-gray'> {t('to')} </span>
                <span className='text-white-filled-default'>
                  {Format.date(endDate, locale, { timeStyle: 'short' })}
                </span>
              </>
            )}
          </p>
        </div>
      )}
      {!within24Hours && (
        <div className='flex items-center space-x-2'>
          <CalendarSvg />
          <p className='font-medium'>
            <span className='text-primary-filled-default'>
              {Format.date(startDate, locale, { dateStyle: 'medium' })}
            </span>
            <span className='text-white-filled-default'>
              , {Format.date(startDate, locale, { timeStyle: 'short' })}
            </span>
            {endDate && (
              <>
                <span className='text-out-light-gray'> {t('until')} </span>
                <span className='text-primary-filled-default'>
                  {Format.date(endDate, locale, { dateStyle: 'medium' })}
                </span>
                <span className='text-white-filled-default'>
                  , {Format.date(endDate, locale, { timeStyle: 'short' })}
                </span>
              </>
            )}
          </p>
        </div>
      )}
    </div>
  );
}
